export default __webpack_public_path__ + "images/1d9e382652752581521279795d444fdb.svg";